const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateCreditManagement = (
  creditCount,
  email,
  otherReasonInput,
  reason
) => {
  if (!EMAIL_REGEX.test(email)) {
    return {
      success: false,
      message: 'Please Enter Correct Email.',
    };
  }
  if (creditCount <= 0) {
    return {
      success: false,
      message: 'Credit count can`t be 0 or Negative(-ve).',
    };
  }
  if (reason === null) {
    return {
      success: false,
      message: 'Please Fill The Reason Correctly.',
    };
  }
  if (reason?.tag === 'other' && otherReasonInput.trim() === '') {
    return {
      success: false,
      message: 'Please Fill The Other Reason Correctly.',
    };
  }

  return {
    success: true,
    message: 'Success',
  };
};
